<app-page-header header="agreements.title" />

<qbe-panel-component>
  <div class="page-container">
    <ng-container [ngSwitch]="agreementsState$ | async">
      <app-agreements *ngSwitchCase="apiState.success">
        <div *ngIf="!(marketingAgreementsIsEmpty$ | async)" class="nx-margin-bottom-4m">
          <p nxCopytext="normal" class="nx-margin-bottom-s">{{ 'agreements.headers.marketing' | translate }}</p>
          <form [formGroup]="formGroup.controls.marketing">
            <nx-checkbox
              *ngIf="selectAllVisible$(agreementType.MARKETING) | async"
              class="nx-margin-bottom-s"
              [checked]="(selectedAllMarketing$ | async) ? 'true' : 'false'"
              (checkboxChange)="handleChangeSelectAll($event, agreementType.MARKETING)"
            >
              {{ 'agreements.checkbox.all' | translate }}
            </nx-checkbox>
            <nx-checkbox
              *ngFor="let control of formGroup.controls.marketing.controls | keyvalue; index as i"
              [formControlName]="control.key"
              class="nx-margin-bottom-s"
            >
              {{ getLabel(i, agreementType.MARKETING) | async }}
            </nx-checkbox>
          </form>
        </div>

        <div *ngIf="!(statementsAgreementsIsEmpty$ | async)" class="nx-margin-bottom-4m">
          <p nxCopytext="normal" class="nx-margin-bottom-s">
            <b><span class="color-danger">*</span> {{ 'agreements.headers.statements' | translate }}</b>
          </p>
          <form [formGroup]="formGroup.controls.statements">
            <nx-checkbox
              *ngIf="selectAllVisible$(agreementType.STATEMENTS) | async"
              class="nx-margin-bottom-s"
              [checked]="(selectedAllStatements$ | async) ? 'true' : 'false'"
              (checkboxChange)="handleChangeSelectAll($event, agreementType.STATEMENTS)"
            >
              {{ 'agreements.checkbox.all' | translate }}
            </nx-checkbox>
            <nx-checkbox
              *ngFor="let control of formGroup.controls.statements.controls | keyvalue; index as i"
              [formControlName]="control.key"
              class="nx-margin-bottom-s"
            >
              {{ getLabel(i, agreementType.STATEMENTS) | async }}
            </nx-checkbox>
          </form>
        </div>

        <ng-container *ngIf="!isAppAgentOrTravelAgency">
          <p nxCopytext="normal" class="nx-margin-bottom-2xs">
            <b>{{ 'agreements.declare' | translate }}</b>
          </p>
          <p nxCopytext="normal" class="agreements-form_copy">
            {{ 'agreements.declaration' | translate }}
          </p>
        </ng-container>
      </app-agreements>
      <app-error *ngSwitchCase="apiState.error" [appError]="statementsAgreementsError$ | async" />
      <app-loader *ngSwitchDefault />
    </ng-container>
  </div>
</qbe-panel-component>
